import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';

import KybTab from 'app/components/Kyb/KybTab';
import OrdersTab from 'app/components/Orders/OrdersTab';
import AuthenticatedPageWrapper from 'app/components/UI/AuthenticatedPageWrapper';

function Approvals() {
  return (
    <AuthenticatedPageWrapper title="Approvals">
      <Tabs mt={2} gap={4} variant="unstyled">
        <TabList>
          <Tab
            borderBottom="1px solid #E2E8F0"
            _selected={{
              color: 'brand.purple',
              borderBottom: '2px solid',
              borderColor: 'brand.purple',
            }}
            px={4}
            py={2}
            fontWeight="medium"
          >
            KYB
          </Tab>
          <Tab
            borderBottom="1px solid #E2E8F0"
            _selected={{
              color: 'brand.purple',
              borderBottom: '2px solid',
              borderColor: 'brand.purple',
            }}
            px={4}
            py={2}
            fontWeight="medium"
          >
            Points orders
          </Tab>
        </TabList>

        <TabPanels mt={4}>
          <TabPanel>
            <KybTab />
          </TabPanel>

          <TabPanel>
            <OrdersTab />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </AuthenticatedPageWrapper>
  );
}

export default Approvals;
